import { ValueOf } from '@/types/util';

export const EFeeCategory = {
  '00': '通常',
  '01': '無金利',
  '02': '手数料加盟店負担',
  '04': '特別売価値引',
  '05': '特別',
  '06': '手数料半減',
  '09': '値引きなし',
} as const;

export type FeeCategoryKey = keyof typeof EFeeCategory;
export type FeeCategoryValue = ValueOf<typeof EFeeCategory>;

export const feeCategoryKeys = Object.keys(EFeeCategory) as FeeCategoryKey[];

/** v-select用items */
export const feeCategoryItems = feeCategoryKeys
  .map((key) => ({
    title: EFeeCategory[key],
    value: key,
  }));
